import { useLazyQuery } from "@apollo/client";
import { GET_COMPANY_BASIC_SETTINGS } from "../../graphql/queries/CompanyAdminContext";

// eslint-disable-next-line import/prefer-default-export
export const useGetCompanyBasicSettings = () => {
  const [getSettings, { error, loading }] = useLazyQuery(GET_COMPANY_BASIC_SETTINGS);

  const executeGetSettings = async ({ companyId, onError, onSuccess }) => {
    try {
      const res = await getSettings({
        variables: {
          companyId,
        },
      });

      const basicSettings = res?.data?.companyAdminContext?.companySettings?.getCompanyBasicSettings;

      if (!!basicSettings) {
        onSuccess?.(basicSettings);
      }
      else {
        onError?.();
      }
    } catch (err) {
      console.error("error >", err);
      onError?.();
    }
  };

  return [executeGetSettings, { error, loading }];
};
